import { useAtom } from "jotai";
import { products_state } from "../components/dataManagers/GlobalDataManagers";
import { discountedPrice } from "../modules/getFinalPrice";

export function useDiscountedPrice(msrpPrice) {
  const [productsState] = useAtom(products_state);
  return discountedPrice(msrpPrice, productsState?.activeObj);
}
